import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Header } from './Header';
import { Footer } from './Footer';

export function Layout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', overflowX: 'hidden' }}>
      <Header />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
}
